<script setup>
</script>
<template>
  <main
    class="mt-[--nf-navbar-height-m] bg-web-basics-BG desktop-sm:mt-[--nf-navbar-height-d]"
  >
    <div class="overflow-hidden">
      <section
        class="relative mb-8 mt-8 flex min-h-[calc(100vh-515px+3rem)] items-start justify-center px-6 sm:mt-8 md:my-20 md:min-h-[calc(100vh-265px+3rem)] md:items-center md:px-4 ipad:my-16 ipad:min-h-[calc(100vh-220px+2rem)] desktop-sm:my-14 desktop-md:my-12 desktop-md:min-h-[calc(100vh-212px+2rem)] desktop-lg:my-16 desktop-lg:min-h-[calc(100vh-260px+4rem)] desktop-xl:my-20 desktop-xl:min-h-[calc(100vh-277px+3rem)] desktop-2xl:min-h-[calc(100vh-300px+2rem)] desktop-3xl:min-h-[calc(100vh-355px+1rem)]"
      >
        <div
          class="inline-flex w-full flex-col items-center xs:text-center justify-center gap-6 md:max-w-[43.75rem] md:flex-row md:justify-between ipad:max-w-[54rem] desktop-sm:max-w-[58.125rem] desktop-md:max-w-[54.125rem] desktop-lg:max-w-[70.188rem] desktop-lg:gap-10 desktop-3xl:max-w-[70.188rem] desktop-3xl:gap-36"
        >
          <div
            class="z-[11] flex items-center justify-center md:w-[27.5rem] md:justify-start md:text-left ipad:w-full desktop-3xl:scale-[1.1]"
          >
            <div class="z-10 overflow-x-clip">
              <div
                class="mb-1 text-white display-2xs ipad:mb-4 ipad:display-xs desktop-md:mb-6 desktop-lg:display-s"
              >
                Introducing<!-- -->
                <span class="relative text-web-teal-500"
                  >Chart 360<img
                    alt="Zig Zag Arrow"
                    loading="lazy"
                    width="34"
                    height="13"
                    decoding="async"
                    data-nimg="1"
                    class="absolute -top-3 right-0"
                    style="color: transparent"
                    src="@/styles/img/pro-website-assets/trade-on-charts/zigzag-arrow.svg"
                /></span>
              </div>
              <h1
                class="mb-6 text-pretty text-web-neutrals-50 display-m md:w-[300px] ipad:mb-3 ipad:w-[525px] ipad:display-2xl desktop-lg:w-[600px] desktop-lg:display-3xl"
              >
                One Screen. Seamless Trading.
              </h1>
              <p
                class="mb-8 xs:hidden text-web-neutrals-400 body-m md:block desktop-lg:mb-10"
              >
                Trade options directly from index charts&nbsp;<span
                  class="font-semibold text-web-teal-500"
                  >without switching screens</span
                >
              </p>
              <div class="flex w-screen gap-4 ipad:w-auto">
                <ul
                  class="relative flex animate-marquee gap-4 md:mb-6 ipad:mb-14 ipad:animate-none ipad:gap-6 ipad:overflow-x-hidden desktop-lg:mb-16"
                >
                  <li class="flex items-center gap-1">
                    <img
                      alt="OI Analysis"
                      loading="lazy"
                      width="24"
                      height="25"
                      decoding="async"
                      data-nimg="1"
                      class="min-w-6"
                      style="color: transparent"
                      src="@/styles/img/pro-website-assets/trade-on-charts/oi-analysis.svg"
                    /><span
                      class="whitespace-nowrap text-white display-2xs desktop-lg:display-xs"
                      >OI analysis</span
                    >
                  </li>
                  <li class="flex items-center gap-1">
                    <img
                      alt="Target Order"
                      loading="lazy"
                      width="24"
                      height="25"
                      decoding="async"
                      data-nimg="1"
                      class="min-w-6"
                      style="color: transparent"
                      src="@/styles/img/pro-website-assets/trade-on-charts/target-order.svg"
                    /><span
                      class="whitespace-nowrap text-white display-2xs desktop-lg:display-xs"
                      >Stop-Loss &amp; Target orders</span
                    >
                  </li>
                  <li class="flex items-center gap-1">
                    <img
                      alt="Payments"
                      loading="lazy"
                      width="24"
                      height="25"
                      decoding="async"
                      data-nimg="1"
                      class="min-w-6"
                      style="color: transparent"
                      src="@/styles/img/pro-website-assets/trade-on-charts/payments.svg"
                    /><span
                      class="whitespace-nowrap text-white display-2xs desktop-lg:display-xs"
                      >Profit &amp; Loss tracking</span
                    >
                  </li>
                </ul>
                <ul
                  class="relative flex animate-marquee gap-4 md:mb-6 ipad:mb-14 ipad:hidden ipad:animate-none ipad:gap-6 ipad:overflow-x-hidden desktop-lg:mb-16"
                >
                  <li class="flex items-center gap-1">
                    <img
                      alt="OI Analysis"
                      loading="lazy"
                      width="24"
                      height="25"
                      decoding="async"
                      data-nimg="1"
                      class="min-w-6"
                      style="color: transparent"
                      src="@/styles/img/pro-website-assets/trade-on-charts/oi-analysis.svg"
                    /><span
                      class="whitespace-nowrap text-white display-2xs desktop-lg:display-xs"
                      >OI analysis</span
                    >
                  </li>
                  <li class="flex items-center gap-1">
                    <img
                      alt="Target Order"
                      loading="lazy"
                      width="24"
                      height="25"
                      decoding="async"
                      data-nimg="1"
                      class="min-w-6"
                      style="color: transparent"
                      src="@/styles/img/pro-website-assets/trade-on-charts/target-order.svg"
                    /><span
                      class="whitespace-nowrap text-white display-2xs desktop-lg:display-xs"
                      >Stop-Loss &amp; Target orders</span
                    >
                  </li>
                  <li class="flex items-center gap-1">
                    <img
                      alt="Payments"
                      loading="lazy"
                      width="24"
                      height="25"
                      decoding="async"
                      data-nimg="1"
                      class="min-w-6"
                      style="color: transparent"
                      src="@/styles/img/pro-website-assets/trade-on-charts/payments.svg"
                    /><span
                      class="whitespace-nowrap text-white display-2xs desktop-lg:display-xs"
                      >Profit &amp; Loss tracking</span
                    >
                  </li>
                </ul>
                <ul
                  class="relative flex animate-marquee gap-4 md:mb-6 ipad:mb-14 ipad:hidden ipad:animate-none ipad:gap-6 ipad:overflow-x-hidden desktop-lg:mb-16"
                >
                  <li class="flex items-center gap-1">
                    <img
                      alt="OI Analysis"
                      loading="lazy"
                      width="24"
                      height="25"
                      decoding="async"
                      data-nimg="1"
                      class="min-w-6"
                      style="color: transparent"
                      src="@/styles/img/pro-website-assets/trade-on-charts/oi-analysis.svg"
                    /><span
                      class="whitespace-nowrap text-white display-2xs desktop-lg:display-xs"
                      >OI analysis</span
                    >
                  </li>
                  <li class="flex items-center gap-1">
                    <img
                      alt="Target Order"
                      loading="lazy"
                      width="24"
                      height="25"
                      decoding="async"
                      data-nimg="1"
                      class="min-w-6"
                      style="color: transparent"
                      src="@/styles/img/pro-website-assets/trade-on-charts/target-order.svg"
                    /><span
                      class="whitespace-nowrap text-white display-2xs desktop-lg:display-xs"
                      >Stop-Loss &amp; Target orders</span
                    >
                  </li>
                  <li class="flex items-center gap-1">
                    <img
                      alt="Payments"
                      loading="lazy"
                      width="24"
                      height="25"
                      decoding="async"
                      data-nimg="1"
                      class="min-w-6"
                      style="color: transparent"
                      src="@/styles/img/pro-website-assets/trade-on-charts/payments.svg"
                    /><span
                      class="whitespace-nowrap text-white display-2xs desktop-lg:display-xs"
                      >Profit &amp; Loss tracking</span
                    >
                  </li>
                </ul>
              </div>
              <div
                class="fixed bottom-0 left-0 right-0 bg-web-basics-BG p-4 md:static md:bg-transparent md:p-0"
              >
                <a
                  class="inline-block cursor-pointer rounded-full disabled:cursor-not-allowed px-6 py-3 button-l sm:px-10 bg-web-purple-800 text-white transition-colors hover:bg-web-purple-700 active:bg-web-purple-900 disabled:bg-web-neutrals-100 disabled:text-web-neutrals-600 m-auto w-full text-center md:w-60"
                  href="https://wa.me/+917092362098"
                  >Sign up</a
                >
              </div>
            </div>
          </div>
          <div
            class="relative block w-full md:w-[12.625rem] md:min-w-[12.625rem] ipad:w-[14.875rem] ipad:min-w-[14.875rem] desktop-lg:w-[18.5rem] desktop-lg:min-w-[18.5rem] desktop-xl:w-[20.25rem] desktop-xl:min-w-[20.25rem]"
          >
            <div
              class="relative z-10 mx-16 rounded-2xl border border-solid border-transparent p-2 gradient-border md:mx-0 ipad:rounded-3xl"
            >
              <video
                class="relative h-full min-h-[16.4rem] w-full rounded-xl mobile:min-h-[21.5rem] sm:min-h-[58rem] md:min-h-[24rem] ipad:min-h-[28.6rem] ipad:rounded-2xl desktop-md:min-h-[29.063rem] desktop-lg:min-h-[36.125rem] desktop-xl:min-h-[39.75rem] desktop-3xl:min-h-[39.75rem]"
                autoplay=""
                muted=""
                playsinline=""
                loop=""
                poster="@/styles/img/pro-website-assets/trade-on-charts/poster-image.webp"
              >
                <source
                  width="306"
                  height="638"
                  src="https://assets.upstox.com/website/video/charts-360-waitlist-video.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
            <div
              class="absolute -right-[110px] top-[50%] z-[1] h-[51px] w-[300px] -translate-y-[50%] rotate-90 transform vertical-gradient-radial sm:-right-[200px] sm:w-[479px] md:-right-[249px] md:w-[449px] desktop-lg:-right-[325px] desktop-lg:w-[600px]"
            ></div>
          </div>
          <div
            class="absolute left-0 top-60 z-0 h-[320px] w-[150px] scale-75 rounded-full bg-web-purple-1200 opacity-40 blur-[200px] sm:h-[850px] sm:w-[350px] md:h-[300px] md:w-[350px] ipad:h-[300px] ipad:w-[550px] desktop-sm:left-32 desktop-sm:w-[450px] desktop-lg:left-40 desktop-lg:h-[550px] desktop-lg:w-[700px] desktop-2xl:left-28 desktop-2xl:h-[550px] desktop-2xl:w-[850px] desktop-2xl:blur-[240px] desktop-3xl:left-20 desktop-3xl:top-60 desktop-3xl:h-[750px] desktop-3xl:w-[1000px] desktop-3xl:blur-[540px]"
          ></div>
          <div
            class="absolute right-0 top-60 z-0 h-[320px] w-[150px] scale-75 rounded-full bg-web-teal-1200 opacity-40 blur-[200px] sm:h-[850px] sm:w-[350px] md:h-[300px] md:w-[350px] ipad:h-[300px] ipad:w-[550px] desktop-sm:right-48 desktop-sm:w-[450px] desktop-lg:right-72 desktop-lg:h-[550px] desktop-lg:w-[700px] desktop-2xl:right-60 desktop-2xl:h-[550px] desktop-2xl:w-[850px] desktop-2xl:blur-[240px] desktop-3xl:right-80 desktop-3xl:top-60 desktop-3xl:h-[750px] desktop-3xl:w-[1000px] desktop-3xl:blur-[540px]"
          ></div>
        </div>
      </section>
    </div>
  </main>
</template>
<style lang="scss">
.display-m {
  font-feature-settings: "ss07" on, "cpsp" on, "ss08" on, "cv05" on, "case" on;
  font-size: 2rem;
  font-weight: 600;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero)
    var(--tw-numeric-figure) var(--tw-numeric-spacing)
    var(--tw-numeric-fraction);
  line-height: 110%;
  letter-spacing: -0.04rem;
}

.display-6xl {
    font-family: InterDisplay,sans-serif;
    font-feature-settings: "ss07" on,"cpsp" on,"ss08" on,"cv05" on,"case" on;
    font-size: 6rem;
    line-height: 1;
    font-weight: 600;
    --tw-ordinal: ordinal;
    --tw-numeric-figure: lining-nums;
    --tw-numeric-spacing: proportional-nums;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
    line-height: 100%;
    letter-spacing: -.24rem
}

.display-2xl {
    font-feature-settings: "ss07" on,"cpsp" on,"ss08" on,"cv05" on,"case" on;
    font-size: 3.5rem;
    font-weight: 600;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
    letter-spacing: -.14rem
}

.display-2xl,.display-l {
    font-family: InterDisplay,sans-serif;
    --tw-ordinal: ordinal;
    --tw-numeric-figure: lining-nums;
    --tw-numeric-spacing: proportional-nums;
    line-height: 110%
}

.display-l {
    font-feature-settings: "ss07" on,"cpsp" on,"ss08" on,"cv05" on,"case" on;
    font-size: 2.5rem;
    font-weight: 600;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
    letter-spacing: -.05rem
}

.display-m {
    font-feature-settings: "ss07" on,"cpsp" on,"ss08" on,"cv05" on,"case" on;
    font-size: 2rem;
    font-weight: 600;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
    line-height: 110%;
    letter-spacing: -.04rem
}

.display-m,.display-s {
    font-family: InterDisplay,sans-serif;
    --tw-ordinal: ordinal;
    --tw-numeric-figure: lining-nums;
    --tw-numeric-spacing: proportional-nums
}

.display-s {
    font-feature-settings: "ss07" on,"cpsp" on,"ss08" on,"cv05" on,"case" on;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 600;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
    line-height: 110%;
    letter-spacing: -.015rem
}

.display-xs {
    font-feature-settings: "ss07" on,"cpsp" on,"ss08" on,"cv05" on,"case" on;
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-weight: 600;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
    line-height: 120%;
    letter-spacing: -.0125rem
}

.display-2xs,.display-xs {
    font-family: InterDisplay,sans-serif;
    --tw-ordinal: ordinal;
    --tw-numeric-figure: lining-nums;
    --tw-numeric-spacing: proportional-nums
}

.display-2xs {
    font-feature-settings: "ss07" on,"cpsp" on,"ss08" on,"cv05" on,"case" on;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 600;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
    line-height: 120%;
    letter-spacing: -.01rem
}
</style>
